import { Navigate, useParams } from "react-router-dom"
import { HEAT_PUMP, NOT_FOUND, STATUS } from "settings/url"

export default function HeatPumpPage() {
	const { interfaceId } = useParams<"interfaceId">()
	if (!interfaceId) return <Navigate to={`/${NOT_FOUND}`} replace /> // should never happen, but just in case, navigate to not found page
	return <Navigate to={`/${HEAT_PUMP}/${interfaceId}/${STATUS}`} replace />
}
